import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Segmented "A A A" font-size control from the design.
 *
 * NOTE: Accessibility font-size scaling is intentionally out of scope for now
 * (per current requirements we only ship language + theme switching). This is
 * rendered as a non-interactive, decorative control so the navbar matches the
 * design. Wire up the click handlers + a font-scale context when implementing
 * the accessibility feature.
 */
export default function FontSizeSelector() {
  const { t } = useTranslation();

  const segments = [
    { label: 'A', fontSize: 16, fontWeight: 500 },
    { label: 'A', fontSize: 18, fontWeight: 500 },
    { label: 'A', fontSize: 20, fontWeight: 600 },
  ];

  return (
    <Box
      role="group"
      aria-label={t('header.fontSize')}
      sx={(theme) => ({
        display: 'flex',
        height: 48,
        borderRadius: `${theme.shape.borderRadius}px`,
        overflow: 'hidden',
        opacity: 0.7,
        cursor: 'not-allowed',
      })}
    >
      {segments.map((segment, index) => (
        <Box
          key={index}
          aria-hidden
          sx={(theme) => ({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 44,
            px: 2,
            border: `1px solid ${theme.app.border}`,
            marginLeft: index === 0 ? 0 : '-1px',
            color: theme.app.foreground,
            fontSize: segment.fontSize,
            fontWeight: segment.fontWeight,
            borderTopLeftRadius: index === 0 ? `${theme.shape.borderRadius}px` : 0,
            borderBottomLeftRadius: index === 0 ? `${theme.shape.borderRadius}px` : 0,
            borderTopRightRadius:
              index === segments.length - 1 ? `${theme.shape.borderRadius}px` : 0,
            borderBottomRightRadius:
              index === segments.length - 1 ? `${theme.shape.borderRadius}px` : 0,
          })}
        >
          {segment.label}
        </Box>
      ))}
    </Box>
  );
}
